import React from 'react'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';

const HeaderBar = () => {
    return (
        < div className='HeaderBar_block'>


            <div className='HeaderBar_media_button'>
                <ListItem button variant="primary" component={Link} to="/Главная">
                    <img className='HeaderBar_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066356152620810322/image.png" alt="" />
                    <ListItemText primary="Главная" className='text_p' />
                </ListItem>
            </div>

            <div className='HeaderBar_media_button'>
                <ListItem button variant="primary" component={Link} to="/Игры" >
                    <img className='HeaderBar_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066355984366305361/image.png" alt="" />
                    <ListItemText primary="Игры" className='text_p' />
                </ListItem>
            </div>


            <div className='HeaderBar_media_button'>
                <ListItem button variant="primary" component={Link} to="/Дискорд" >
                    <img className='HeaderBar_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066355850035347476/image.png" alt="" />
                    <ListItemText primary="Discord" className='text_p' />
                </ListItem>
            </div>

            <div className='HeaderBar_media_button'>
                <ListItem button variant="primary" component={Link} to="/Valheim" >
                    <img className='HeaderBar_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066355665737629726/image.png" alt="" />
                    <ListItemText primary="Valheim" className='text_p' />
                </ListItem>
            </div>

            <div className='HeaderBar_media_button'>
                <ListItem button variant="primary" component={Link} to="/DontStarveTogether" >
                    <img className='HeaderBar_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066355249037709382/image.png" alt="" />
                    <ListItemText primary="Dont Starve Together" className='text_p' />
                </ListItem>
            </div>

            <div className='HeaderBar_media_button'>
                <ListItem button variant="primary" component={Link} to="/Minecraft" >
                    <img className='HeaderBar_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066354300487475211/2147194.png" alt="" />
                    <ListItemText primary="Minecraft" className='text_p' />
                </ListItem>
            </div>

            <div className='HeaderBar_media_button'>
                <ListItem button variant="primary" component={Link} to="/Donate" >
                    <img className='HeaderBar_image' src="https://media.discordapp.net/attachments/1047046814672629820/1066355477149126757/2704312.png" alt="" />
                    <ListItemText primary="Поддержка" className='text_p' />
                </ListItem>
            </div>

        </div>
    )
}

export default HeaderBar
